import { INews } from '../../../common/tin-gpt/define-news';
import VerticalNews from '../VerticalNews/VerticalNews';
import HorizontalCategory from './HorizontalCategory';
import './styles.categoryNews.scss';

interface Props {
    categoryHorizontalNews: any;
    newsContent: INews[];
    numberNews: any;
}

const CategoryNewsMain = (props: Props) => {

    console.log(props.categoryHorizontalNews);


    return (
        <div className='category-news-main'>
            <HorizontalCategory
                categoryHorizontalNews={props.categoryHorizontalNews}
                numberNews={props.numberNews - 1}
            />
            <div className='content-category-news-main'>
                {props.newsContent.slice(1, 4).map((news: any, index) => (
                    <div className='category-news-item'>
                        <VerticalNews
                            newsContent={news}
                            type={'reverse'}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CategoryNewsMain
